import {React, useContext} from 'react'
import { Link } from 'react-router-dom'
import BreadcrumbsSection from './BreadcrumbsSection'
import news_example_1 from './static/img/news_example_1.jpg'
import news_example_2 from './static/img/news_example_2.jpg'
import news_example_3 from './static/img/news_example_3.jpg'
import news_example_4 from './static/img/news_example_4.jpg'
import news_example_5 from './static/img/news_example_5.jpg'
import RoutesContext from '../contexts/RoutesContext'

function NewsArticlesPage(props) {
    let routes_context = useContext(RoutesContext)
  return (
    <main>
        <BreadcrumbsSection routes={routes_context.routes} page_name="News and Articles" />

        <div className="news_section active">
            <div className="news_section_inner_wrapper width_1440">
                <h1 className="news_section_title">News and articles</h1>
                <div className="news_first_row">
                    <div className="news_card">
                        <img src={news_example_1} alt="" />
                        <div className="news_card_text">
                            <span className="news_date">09.12.2021</span>
                            <h3 className="news_title">Türkmenistanda ekologiýa ýagdaýlar kämilleşdirilýär</h3>
                            <p className="news_content">Türkmenistanyň Oba hojalyk we daşky gurşawy goramak ministrligi we BMG-niň ÖM bilen bilelikde guramagynda «Türkmenistanda durn...</p>
                            <Link to={routes_context.routes.single_news.path} className="more_button"><span className="btn_animation green">Details</span></Link>
                        </div>
                    </div>

                    <div className="news_card">
                        <img src={news_example_2} alt="" />
                        <div className="news_card_text">
                            <span className="news_date">23.11.2021</span>
                            <h3 className="news_title">Türkmenistanyň Kanuny «Ekologiýa howpsuzlygy hakynda» Türkmenistanyň Kanunyna goşmaçalar we üýtgetmeler girizmek hakynda</h3>
                            <p className="news_content">I. 2017-nji ýylyň 3-nji iýunynda kabul edilen «Ekologiýa howpsuzlygy hakynda» Türkmenistanyň Kanunyna (Tü...</p>
                            <Link to={routes_context.routes.single_news.path} className="more_button"><span className="btn_animation green">Details</span></Link>
                        </div>
                    </div>

                    <div className="news_card">
                        <img src={news_example_3} alt="" />
                        <div className="news_card_text">
                            <span className="news_date">23.11.2021</span>
                            <h3 className="news_title">Türkmenistanyň goraghanalary – bioköpdürlüligiň sakçylary</h3>
                            <p className="news_content">Türkmenistanda özboluşly ösümlik we haýwanat dünýäsine baý ekologiýa ulgamlarynyň dü...</p>
                            <Link to={routes_context.routes.single_news.path} className="more_button"><span className="btn_animation green">Details</span></Link>
                        </div>
                    </div>
                </div>

                <div className="news_second_row">
                    <div className="news_card_big">
                        <img src={news_example_4} alt="" />
                        <div className="news_card_big_text">
                            <span className="news_date">14.11.2021</span>
                            <h3 className="news_title">Plastmassanyň ýerine ekologiýa taýdan arassa we modaly esbaplar</h3>
                            <p className="news_content">Bütin dünýäniň daşky gurşawy hapalaýan plastika garşy göreşýän häzirki döwründe dü...</p>
                            <Link to={routes_context.routes.single_news.path} className="more_button"><span className="btn_animation green">Details</span></Link>
                        </div>
                    </div>

                    <div className="news_card_big">
                        <img src={news_example_5} alt="" />
                        <div className="news_card_big_text">
                            <span className="news_date">07.11.2021</span>
                            <h3 className="news_title">Milli Liderimiz ählihalk bag ekmek dabarasyna gatnaşdy</h3>
                            <p className="news_content">6-njy noýabrda hormatly Prezidentimiz Gurbanguly Berdimuhamedowyň gatnaşmagynda ýurdumyzyň şäherleriniň we obalarynyň daş-tö...</p>
                            <Link to={routes_context.routes.single_news.path} className="more_button"><span className="btn_animation green">Details</span></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pagination_section">
            <div className="pagination_inner_wrapper">
                <div className="pagination_button active"><Link to={routes_context.routes.news_articles.path}>1</Link></div>
                <div className="pagination_button"><span>...</span></div>
                <div className="pagination_button"><Link to={routes_context.routes.news_articles.path}>4</Link></div>
                <div className="pagination_button"><Link to={routes_context.routes.news_articles.path}>5</Link></div>
                <div className="pagination_button"><Link to={routes_context.routes.news_articles.path}>6</Link></div>
                <div className="pagination_button"><span>...</span></div>
                <div className="pagination_button active"><Link to={routes_context.routes.news_articles.path}>9</Link></div>

            </div>
        </div>


    </main>

  )
}

export default NewsArticlesPage